export const ACCOUNT_EMAIL = /^(?=.*[A-Za-z])[0-9A-Za-z-]{5,50}$|^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

// export const PWD = /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,50}$/;
export const PWD = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+={}\[\]:;"'<>,.?/|\\-]{6,50}$/;

export const EMAIL = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.([A-Za-z]{2,4})$/;

export const CODE = /^[0-9]{6}$/;

export const DESCRIPTION = /^(?!.*\s+$)(?!.*[<>]).{1,200}$/;

export const SIGNCODE = /^[A-Za-z0-9_.]{2,50}$/;

export const DOUBLE = /^-?\d+\.\d{1,3}$/;

export const INT = /^(-?\d{1,15})$/;
export const STEP = /^\d*\.?\d+$/;



// 限制输入只能包含数字和字母
export const LETTERNUM = /^[a-zA-Z0-9]*$/;

export const ENUMKEY = /^[a-zA-Z0-9]{1,10}$/;

export const ENUMSTRING = /^(?!.*\s+$)(?!.*[<>]).{1,50}$/;

export const STRING = /^(?!.*\s+$)(?!.*[<>]).{2,50}$/;

export const ACCOUNT = /^(?=.*[A-Za-z])[0-9A-Za-z\-]{5,50}$/;

export const STRING2TO200 = /^(?!.*\s+$)(?!.*[<>]).{2,200}$/;

export const DOMAIN = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63}(?<!-)){0,}$/;

export const IDLONG = /^\d{1,20}$/;

export const SPACE = /^\S+$/

export const NUMWORD = /^(?=.*[a-zA-Z])(?=.*\d).+$/

export const CHINESE = /^[^\u4e00-\u9fa5]*$/

export const IDMAC = /^[0-9A-Fa-f:.-]+$/
